import { ViewModel, View, ObservableArray } from "binder"
import { WreckedProductManipulationView } from "./wreckedProductManipulation-view"
import { PaginationInfo, ServerSideDataLoader } from "uicomponents";
import { CurrentDistrictWarehousesSelectorViewModel, WarehouseSelectorViewModel } from "../warehouseManipulation/warehouseManipulation-viewModel";
import { ProductSearchableSelectorViewModel } from "../productSearch/productSearchableSelector/productSearchableSelector-viewModel";
import { ServerConnection } from "src/server/serverConnection";
import { stringIsNullOrEmpty } from "src/common/utilities";
import { WindowViewModel } from "src/common/userMainWindow/windowContainer/windowContainer-viewModel";
import { ImageChooserViewModel, singleFile } from "./imageChooser/imageChooser-viewModel";

export class WreckedProductManipulationViewModel extends WindowViewModel {
    public getTitle(): string {
        return 'ایجاد کالای معیوب';
    }
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);

        this.loader = new ServerSideDataLoader(x => this.refreshPaged(x), 30);
        this.warehouseSelector = new CurrentDistrictWarehousesSelectorViewModel(this, true);
        this.productSearch = new ProductSearchableSelectorViewModel(this, true, false);
        this.items = ObservableArray.create<lineItem>();
        this.files = ObservableArray.create<singleFile>();

        this.warehouseSelector.onSelectionChanged = x => this.refreshCurrentProduct();
        this.productSearch.onSelectionChanged = x => {
            this.selectedMeasuredProductId = x.measuredProducts[0].id;
            this.selectedProductId = x.id;
            this.productName = x.productName;
            this.productCode = x.code;
            this.productCarModel = x.productCarModel;
            this.refreshCurrentProduct();
        };

        this.loader.refresh();
    }
    GetDefaultView(): View<ViewModel> {
        return new WreckedProductManipulationView();
    }
    public getTypeId(): string {
        return "VM-32E2C665-3484-4803-8463-2509544483B9"
    }

    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading; } private _isLoading: boolean;
    public set loader(v: ServerSideDataLoader) { this._loader = v; } public get loader(): ServerSideDataLoader { return this._loader; } private _loader: ServerSideDataLoader;
    public set warehouseSelector(v: CurrentDistrictWarehousesSelectorViewModel) { this._warehouseSelector = v; } public get warehouseSelector(): CurrentDistrictWarehousesSelectorViewModel { return this._warehouseSelector; } private _warehouseSelector: CurrentDistrictWarehousesSelectorViewModel;
    public set productSearch(v: ProductSearchableSelectorViewModel) { this._productSearch = v; } public get productSearch(): ProductSearchableSelectorViewModel { return this._productSearch; } private _productSearch: ProductSearchableSelectorViewModel;

    public set selectedProductId(v: string) { this._selectedProductId = v; } public get selectedProductId(): string { return this._selectedProductId; } private _selectedProductId: string;
    public set selectedMeasuredProductId(v: string) { this._selectedMeasuredProductId = v; } public get selectedMeasuredProductId(): string { return this._selectedMeasuredProductId; } private _selectedMeasuredProductId: string;
    public set productName(v: string) { this._productName = v; } public get productName(): string { return this._productName; } private _productName: string;
    public set productCode(v: string) { this._productCode = v; } public get productCode(): string { return this._productCode; } private _productCode: string;
    public set productCarModel(v: string) { this._productCarModel = v; } public get productCarModel(): string { return this._productCarModel; } private _productCarModel: string;
    public set balance(v: number) { this._balance = v; } public get balance(): number { return this._balance; } private _balance: number;
    public set accessibleBalance(v: number) { this._accessibleBalance = v; } public get accessibleBalance(): number { return this._accessibleBalance; } private _accessibleBalance: number;
    public set location(v: string) { this._location = v; } public get location(): string { return this._location; } private _location: string;
    public set items(v: ObservableArray<lineItem>) { this._items = v; } public get items(): ObservableArray<lineItem> { return this._items; } private _items: ObservableArray<lineItem>;
    public set noSaleLockAmount(v: number) { this._noSaleLockAmount = v; } public get noSaleLockAmount(): number { return this._noSaleLockAmount; } private _noSaleLockAmount: number;
    public set problem(v: string) { this._problem = v; } public get problem(): string { return this._problem; } private _problem: string;
    public set files(v: ObservableArray<singleFile>) { this._files = v; } public get files(): ObservableArray<singleFile> { return this._files; } private _files: ObservableArray<singleFile>;

    refresh() {
        this.loader.refresh();
    }

    async setPictures() {
        let popup = new ImageChooserViewModel(this);
        popup.loadFiles(...this.files);
        let result: any = await this.showPopup(popup);
        if (result != null) {
            this.files.update(...result);
        }
    }

    async refreshPaged(filteringInformation: any): Promise<PaginationInfo> {
        try {
            this.isLoading = true;
            let result = await ServerConnection.callServer('/Complex/WarehouseServices/GetAllWreckedProducts', {
                FilteringInformation: filteringInformation
            });
            this.items.update(...result.Products.map((x, i) => {
                let r = new lineItem(this);
                r.id = x.MeasuredProductId;
                r.index = i + 1;
                r.name = x.Name;
                r.code = x.Code;
                r.productCarModel = x.ProductCarModel;
                r.balance = x.Balance;
                r.accessibleBalance = x.AccessibleBalance;
                r.warehouseName = x.WarehouseName;
                r.description = x.Description;
                return r;
            }))
            return new PaginationInfo(result.PaginationInfo.CurrentPage, result.PaginationInfo.PageCount);
        } catch (ex) {
            console.log(ex);
            return new PaginationInfo(0, 0);
        } finally {
            this.isLoading = false;
        }
    }
    async create() {
        let validationResult = this.validate();
        if (validationResult.length > 0) {
            let msg = validationResult.join('\r\n');
            this.messageBoxConfirmWarning(msg, 'عدم امکان انجام عملیات');
            return;
        }
        let confirmationResult = await this.messageBoxWarningYesNo(`آیا کالا باکد ${this.productCode} در انبار ${this.warehouseSelector.selectedItem.title} معیوب شود؟`, 'تایید عملیات');
        if (confirmationResult == 'no')
            return;

        try {
            this.isLoading = true;
            let result = await ServerConnection.callServer('/Complex/WarehouseServices/CreateWreckedProduct', {
                MainMeasuredProductId: this.selectedMeasuredProductId,
                WarehouseId: this.warehouseSelector.selectedItem.id,
                Problem: this.problem,
                Images: this.files.map(x => {
                    return {
                        Name: x.name,
                        Content: x.content
                    };
                })
            });
            if (result.IsSuccessful == true) {
                this.files.clear();
                this.messageBoxConfirmSuccess("عملیات با موفقیت انجام شد.", "عملیات موفق")
                this.selectedProductId = "";
                this.selectedMeasuredProductId = "";
                this.productName = "";
                this.productCode = "";
                this.balance = 0;
                this.accessibleBalance = 0;
                this.location = "";
                this.noSaleLockAmount = 0;
                this.problem = "";
            } else {
                this.messageBoxConfirmWarning("خطا در انجام عملیات.", "عملیات نا موفق")
            }
        } catch (ex) {
            console.log(ex);
            this.messageBoxConfirmWarning("خطا در انجام عملیات.", "عملیات نا موفق")
        } finally {
            this.isLoading = false;
            this.loader.refresh();
        }
    }
    private validate(): string[] {
        let result: string[] = [];
        if (this.warehouseSelector.selectedItem == null)
            result.push('انبار انتخاب نشده است.');
        if (stringIsNullOrEmpty(this.selectedProductId))
            result.push('کالا مشخص نشده است.');
        if (this.accessibleBalance <= 0)
            result.push('میزان موجودی کالا کافی نیست.');
        if (stringIsNullOrEmpty(this.problem))
            result.push('لطفا توضیحات را وارد کنید.');
        return result;
    }
    async refreshCurrentProduct() {
        if (this.warehouseSelector.selectedItem == null)
            return;
        if (stringIsNullOrEmpty(this.selectedMeasuredProductId))
            return;

        try {
            this.isLoading = true;
            let result = await ServerConnection.callServer('/Complex/WarehouseServices/GetSingleProductBalanceInfo', {
                ProductId: this.selectedProductId
            });
            let relatedWarehouseItem = result.Balances.filter(x => x.WarehouseId == this.warehouseSelector.selectedItem.id).at(0);
            if (relatedWarehouseItem == null)
                return;
            this.balance = relatedWarehouseItem.Balance;
            this.accessibleBalance = relatedWarehouseItem.AccessibleBalance;
            this.noSaleLockAmount = relatedWarehouseItem.LockedNoSaleAmount;
            this.location = relatedWarehouseItem.Location;
        } catch (ex) {
            console.log(ex);
        } finally {
            this.isLoading = false;
        }
    }
}

export class lineItem extends ViewModel {
    public getTypeId(): string { return ''; }
    public GetDefaultView(): View<ViewModel> { return null; }
    constructor(parent: ViewModel) {
        super(parent);

    }
    public set index(v: number) { this._index = v; } public get index(): number { return this._index; } private _index: number;
    public set id(v: string) { this._id = v; } public get id(): string { return this._id; } private _id: string;
    public set code(v: string) { this._code = v; } public get code(): string { return this._code; } private _code: string;
    public set name(v: string) { this._name = v; } public get name(): string { return this._name; } private _name: string;
    public set productCarModel(v: string) { this._productCarModel = v; } public get productCarModel(): string { return this._productCarModel; } private _productCarModel: string;
    public set balance(v: number) { this._balance = v; } public get balance(): number { return this._balance; } private _balance: number;
    public set accessibleBalance(v: number) { this._accessibleBalance = v; } public get accessibleBalance(): number { return this._accessibleBalance; } private _accessibleBalance: number;
    public set warehouseName(v: string) { this._warehouseName = v; } public get warehouseName(): string { return this._warehouseName; } private _warehouseName: string;
    public set isReceipt(v: boolean) { this._isReceipt = v; } public get isReceipt(): boolean { return this._isReceipt;} private _isReceipt: boolean;
    public set description(v: string) { this._description = v; } public get description(): string { return this._description; } private _description: string;
}